module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/150-bolivia-841f5fd3949426472bb786fc28439fd8.svg";